import StepModel from "../../../model/configurator/StepModel";

export default class StepsManager {
    steps: { [key: string]: StepModel } = {}

    addStepModel(name: string, instance: StepModel) {
        this.steps[name] = instance
    }

    hasStepModel(name: string) {
        return name in this.steps
    }

    removeStepModel(name: string) {
        delete this.steps[name]
    }

    getStepByName(name: string) {
        return this.steps[name]
    }

    getAll() {
        return Object.values(this.steps)
    }
}